'use client';

import { useSelector } from 'react-redux';
import { selectFeatureToggles } from '@next-app/lib/features/InitSelectors';

interface iReviewCount {
  classesname?: string;
  reviewcount: string;
}

const ReviewCount = ({ classesname, reviewcount }: iReviewCount) => {
  const featureToogle = useSelector(selectFeatureToggles);
  const enhancedTypeAheadEnabled =
    featureToogle?.enhancedTypeAheadEnabled ?? false;
  return (
    <span
      style={{ marginLeft: '6px' }}
      className={`ll-fs-12 ${classesname} d-inline-block  ${enhancedTypeAheadEnabled ? '' : ''}`}
    >
      ({reviewcount})
    </span>
  );
};

export default ReviewCount;
